'use client';

import TransitionItem from './TransitionItem';
import { TRANSITION_PRESETS } from './transition-presets';

export default function TransitionContent() {
  return (
    <div className="flex h-full w-full flex-col px-md py-sm">
      <div className="grid grid-cols-2 gap-2xs overflow-y-auto layout-padding-bottom">
        {TRANSITION_PRESETS.map((preset) => (
          <TransitionItem
            key={preset.type}
            type={preset.type}
            name={preset.name}
          />
        ))}
      </div>
    </div>
  );
}
